import type { HeadlineResponse } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { toFriendlyDate } from '@on3/ui-lib/src/utils/date';
import { PremiumArticleLock } from '@public/components/Headlines/PremiumArticleLock';
import { ResizedImage } from '@public/components/Image/ResizedImage';
import clsx from 'clsx';

import styles from './ArticleFeed.module.scss';

interface IArticleFeedProps extends HeadlineResponse {
  className?: string;
  primaryColor?: string;
}

export const ArticleFeedArticle = ({
  featuredImage,
  title,
  fullUrl,
  author,
  postDate,
  isPremium,
  primaryCategory,
  className,
  primaryColor,
}: IArticleFeedProps) => {
  let baseUrl = primaryCategory?.fullUrl;
  const hideCategory = primaryCategory?.key === 557908;

  if (baseUrl?.endsWith('/')) {
    baseUrl = baseUrl.slice(0, -1);
  }

  return (
    <article className={clsx(styles.block, className)} data-ui="feed-article">
      {featuredImage && (
        <Link className={styles.imageWrapper} href={fullUrl}>
          <ResizedImage
            {...featuredImage}
            className={styles.image}
            fit="cover"
            gravity="0.5x0.5"
            height={100}
            quality={90}
            width={160}
          />
        </Link>
      )}

      <div className={styles.content}>
        {primaryCategory?.name && !hideCategory && (
          <Link
            className={styles.category}
            href={`${baseUrl}/news/`}
            style={{ color: primaryColor }}
          >
            <span>{primaryCategory?.name}</span>
          </Link>
        )}

        <Link className={styles.title} href={fullUrl}>
          <h3>{title}</h3>
        </Link>

        <div className={styles.authorContainer}>
          <div className={styles.meta}>
            <Link href={`/user/${author?.niceName}/`}>
              <span>{author?.name}</span>
            </Link>
            <span className={styles.date}>{toFriendlyDate(postDate)}</span>
          </div>
          {isPremium && (
            <figure className={styles.premiumIcon}>
              <PremiumArticleLock />
            </figure>
          )}
        </div>
      </div>
    </article>
  );
};
